module.exports = __webpack_public_path__ + "media/about/Website_Map-da2e1b40.png";